import { motion } from "framer-motion";

const items = [
  {
    title: "International Business Network",
    desc: "Active relationships with manufacturers, distributors and investors across Türkiye, Europe, the Middle East and beyond.",
  },
  {
    title: "Professional Representation",
    desc: "Acting as your in-country commercial agent with discretion, language fluency and deep market intelligence.",
  },
  {
    title: "Confidential Business Handling",
    desc: "NDA-backed protocols protect proprietary requirements, partner identities and pricing throughout every engagement.",
  },
  {
    title: "Strategic Commercial Matching",
    desc: "Counterparts are screened on capacity, certifications, references and cultural fit — not just availability.",
  },
  {
    title: "Reliable Communication",
    desc: "Single point of contact, multilingual reporting, predictable cadence — no dropped threads, no silent gaps.",
  },
  {
    title: "Long-Term Partnerships",
    desc: "We optimise for compounding value, returning to nurture relationships long after the first transaction closes.",
  },
  {
    title: "High Professional Standards",
    desc: "Codified business ethics, written engagement letters and clear deliverables on every mandate we accept.",
  },
  {
    title: "Tailored Commercial Solutions",
    desc: "Every brief is bespoke — from one-off sourcing to multi-year market entry programmes.",
  },
];

export default function WhyUs() {
  return (
    <section
      id="why-us"
      data-testid="why-us-section"
      className="py-24 md:py-32 bg-altin-bg"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
          <div className="lg:col-span-5">
            <div className="lg:sticky lg:top-28">
              <div className="flex items-center gap-3 mb-6">
                <span className="gold-divider" />
                <span className="overline">Why Altin Link</span>
              </div>
              <h2 className="font-serif-display text-4xl md:text-5xl leading-[1.05] text-altin-ink tracking-tight">
                Why partner <br />
                with <span className="italic text-altin-gold">us</span>?
              </h2>
              <p className="mt-6 text-altin-muted leading-relaxed max-w-md">
                Eight reasons international companies choose Altin Link as
                their commercial bridge into new markets.
              </p>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="space-y-px bg-altin-border border-y border-altin-border">
              {items.map((item, i) => (
                <motion.div
                  key={item.title}
                  data-testid={`why-item-${i}`}
                  initial={{ opacity: 0, x: 20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, amount: 0.15 }}
                  transition={{ duration: 0.5, delay: (i % 4) * 0.07 }}
                  className="group bg-altin-bg relative py-8 px-6 md:px-10 hover:bg-white transition-colors duration-300"
                >
                  <div className="grid grid-cols-12 gap-6 items-baseline">
                    <span className="col-span-2 font-serif-display text-4xl md:text-5xl text-altin-gold/30 group-hover:text-altin-gold transition-colors">
                      0{i + 1}
                    </span>
                    <div className="col-span-10">
                      <h3 className="font-serif-display text-xl md:text-2xl text-altin-ink tracking-tight">
                        {item.title}
                      </h3>
                      <p className="mt-2 text-sm text-altin-muted leading-relaxed max-w-xl">
                        {item.desc}
                      </p>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
